module.exports = __webpack_public_path__ + "img/blueCross.f3c5ad63.svg";